import dayjs from "dayjs";
import useHasMounted from "@/hooks/useHasMounted";
import { fromNow } from "@/utils/dateTimeFormat";

const TimeAgo = ({ dateTime }) => {
  const hasMounted = useHasMounted();
  if (!dateTime) return null;
  return hasMounted ? fromNow(dateTime) : dayjs(dateTime).format("MMM DD YYYY");
};

export default TimeAgo;
